import { render, staticRenderFns } from "./mapa_prescricao.vue?vue&type=template&id=5125f440&scoped=true"
import script from "./mapa_prescricao.vue?vue&type=script&lang=js"
export * from "./mapa_prescricao.vue?vue&type=script&lang=js"
import style0 from "./mapa_prescricao.vue?vue&type=style&index=0&id=5125f440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125f440",
  null
  
)

export default component.exports